import { render, staticRenderFns } from "./YourStuffPageHeader.vue?vue&type=template&id=5e0722a4&scoped=true"
import script from "./YourStuffPageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./YourStuffPageHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourStuffPageHeader.vue?vue&type=style&index=0&id=5e0722a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0722a4",
  null
  
)

export default component.exports